import { Img } from "@/components/blocks/MaterialImage";
import { useLocalization } from "@/data/Localization";
import { useSettings } from "@/data/Settings";
import { Stack, TableCell, TableRow, Typography } from "@mui/material";
import { FC } from "react";

export const DonationItemMessage: FC = () => {

    const { settings } = useSettings();
    const thumbnail = settings.userData.DonateItemPartNumberThumbnail;
    const orderItemTableNLS = useLocalization('OrderItemTable');
    
    return (
        <TableRow>
            <TableCell colSpan={4}>
                <Stack direction="row" alignItems="flex-start" spacing={2}>
                    <Stack direction="column" alignItems="flex-start" rowGap={1}>
                        <Typography variant="body1">{orderItemTableNLS.Msgs.SpeelboekMsg.t()}</Typography>
                    </Stack>
                    <Img
                        {...{
                            src: thumbnail,
                            alt: orderItemTableNLS.Labels.ProductThumbnail.t(),
                            isThumbnail: true,
                            sx: { maxWidth: '3.8em !important' },
                        }}
                    />
                </Stack>
            </TableCell>
        </TableRow>
    );
}